export default __webpack_public_path__ + "static/rocket-10fbad0d60090a129379a4dbf6a93f5c.svg";